export default {
  Auth: '權限',
  Auth_Desc: '',
  Customer: '客戶',
  Customer_Desc: '',
  CustomerManageReporter: '會員管理報表',
  ManageRole: '角色管理',
  ManageUser: '用戶管理',
  ManageUserList: '用戶管理列表',
  ManageUserRole: '用戶角色管理',
  MemberManagement: '會員管理',
  MemberList: '會員',
  ProspectiveCustomerList: '潛客',
  RedeemManagement: '兌禮管理',
  RedeemItemManagement: '禮品管理',
  RedeemOrderManagement: '訂單管理',
  RichMenuManagement: '圖文選單管理',
  Market: '行銷',
  Market_Desc: '',
  QuestionnaireList: '問卷管理',
  ActivityManagement: '行銷活動',
  Admin: 'Admin',
  Admin_Desc: '',
  SocialBroadcastsService: '行銷群發',
  CommunicationAutoReply: '自動回覆',
  QRCodeManagement: 'QR Code行銷',
  Report: '數據',
  Report_Desc: '',
  RPLineMember: '綁定會員明細',
  RPUser: '帳號使用狀態',
  RPKeyword: '自動回覆明細',
  RPActivityResult: '活動結果明細',
  RPActivityEffect: '活動成效分析',
  RPGroupMsgEffect: '群發成效分析',
  RewardManagement: '優惠與獎項',
  ConsiderableTagAlter: '批量貼標修改',
  RPLoginLogout: '登入登出紀錄',
  RPActionRecord: '操作日誌',
  RPKeywordActionRecord: '自動回覆點擊統計',
  RPRichmenuClick: '圖文選單點擊量',
  Chat: '溝通',
  RPGroupMsgEffectMysql: '群發成效分析',
  RPActivityEffectMysql: '一般活動成效分析',
  RPActivityResultMysql: '活動中獎清單',
  RPKeyWordMysql: '自動回覆觸發成效',
  RPKeywordActionRecordMysql: '自動回覆點擊成效',
  RPRichmenuClickMysql: '圖文選單點擊成效',
  RPRichmenuDailyClickMysql: '圖文選單成效分析',
  Management: '管理',
  QuickReplySetting: '快捷回覆設定',
  ChannelSetting: '渠道設定',
  RPMemberAnalysisMysql: '會員分析報表',
  GroupSetting: '顧問參數設定',
  AgentParameterSetting: '客服參數設定',
  Setting: '設定',
  NopCommerce: '電商後台',
  RPSalesAnalysisMysql: '銷售分析報表',
  RPOrderSalesDetailsMysql: '訂單明細',
  RPQRCodeScanMysql: 'QR Code行銷成效分析',
  Shop: '電商',
  ShopSetting: '維護',
  Shop_Desc: '(開啟此功能後，可用此平台的帳密登入電商中心後台使用)',
  RPMgmActivityEffectMysql: '會員邀請活動成效',
  CloudShopManagement: '雲店管理',
  CloudShopManagementSetting: '雲店管理',
  RPDaliyMktItemResultMysql: '每日獎項使用狀況',
  RPDaliyMktItemResult: '每日獎項使用狀況',
  CloudShopSharing: '溝通分流業績設定',
  RPQuestionnarieDetails: '問卷資料匯出',
  RPProductSalesAnalysisMysql: '商品銷售明細',
  RPCloudStoreSalesAnalysisMysql: '雲店銷售分析報表',
  RPNewOrderSalesDetailsMysql: '訂單銷售明細',
  AgentServiceSetting: '客服分流設定',
  ConsultantSetting: '顧問分流設定',
  RPCouponUsageMysql: 'Coupon成效分析',
  ConsultantServicechat: '顧問工作台',
  CustomerServiceChat: '客服工作台',
  RPChatAnalysisMysql: '客服對話分析',
  RPAgentDialogRecordMysql: '客服對話紀錄',
  RPAgentPerformance: '客服即時績效',
  RPAgentMonitoringMysql: '客服專員監控',
  RPConsultantDialogMySql: '顧問對話紀錄',
  RPPromotePerformanceMySql: '推播語成效',
  RPConsultantServiceAnalysis: '顧問績效報表',
  RPLoginLogoutMySql: '登入登出報表',
  RPAgentTotalPerformanceMysql: '客服績效報表',
  RPDailyPerformanceMySql: '每日營運績效',
  RPTimePerformanceMySql: '時段營運績效',
  RPSatisfactionDetailsMysql: '智能客服滿意度',
  RPConsultantSatisfactionMysql: '智能顧問滿意度',
  GroupCustomer: '集團會員管理',
  RPCommentDetailMySql: '留言明細',
  OnlineConsultant: '線上顧問',
  OnlineService: '線上客服',
  MemberReport: '會員數據',
  MarketReport: '行銷數據',
  MarketingPitch: '行銷推播語',
  ChatReport: '溝通數據',
  ShopReport: '電商數據',
  Chatbot: '智能',
  ChatbotParamSetting: '機器人參數設定',
  ChatbotSetting: '機器人設定',
  DialogueQualityManagement: '對話品質管理',
  KnowledgeSetting: '知識管理',
  KnowledgeCategorySetting: '知識分類設定',
  RPNewProductSalesAnalysisMysql: '商品銷售及回購分析',
  VocabularyManage: '詞彙管理',
  AQuestionManage: '問答管理',
  IntelligentQualityInspection: '智能質檢',
  IntelligentReport: '智能數據',
  RPKnowledgeAnalysisMysql: '知識學習分析',
  RPKnowledgeLogAnalysisMysql: '知識庫操作日誌',
  RPSmartDialogRecordMysql: '智能對話紀錄',
  RPPopularQuestionMysql: '熱門題組明細',
  RPPopularQuestionAnalysisMysql: '熱門題組分析',
  PointBonusManagement: '積點管理',
  KnowledgeDeleted: '已下架問答知識',
  PreciseNavigationDialogue: '精準導航對談',
  RPQuestionnarieDetailsMysql: '問卷資料匯出',
  RPPeriodGroupMsgEffectMysql: '智能群發成效分析',
  PreciseNavigationDeleted: '已下架精準導航對談',
  TagManagement: '標籤管理',
  BatchTagManagement: '批量標籤管理',
  CallOfferByConsultantAnalysis: '智能顧問服務量',
  CallOfferByAgentAnalysis: '智能客服服務量',
  ChatbotResponseAnalysis: '答題能力分析',
  LearningList: '待學習知識',
  AudienceListManagement: '分眾名單管理',
  RPTally: '顧問問題紀錄報表',
  WarrantyList: '保固清單管理',
  Moztech: '客製',
  RPMoztechWarrantyRecordsMysql: '保固明細報表',
  WarrantyMailEdit: '保固狀態信件編輯',
  WarrantyTermsEdit: '保固條款維護',
  WaitingReceiveN: '(N)等待收件',
  MaintenanceN: '(N)檢修中',
  MaintenanceCompletedN: '(N)檢修已完成',
  ConfirmN: '(N)確認',
  MaintenanceF: '(F)檢修中',
  MaintenanceCompletedF: '(F)檢修已完成-已回寄'
};
